import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';

/**
 * for this page
 */
import SubNav from '../../../components/subNav';
import TabNav from '../../../components/tabNav';
import DataTable from './dataTable';

class Content extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {};

    render() {
        const { subNav, tabNav } = this.props.content;

        return (
            <div className={styles.content}>
                <Chip id="170094" type="struct" title="副导航" groupName="正文" content={subNav}>
                    <SubNav />
                </Chip>
                <Chip id="200085" type="struct" title="tab导航" groupName="正文" content={tabNav}>
                    <TabNav curUrl={'/newStock/shanghui'} />
                </Chip>
                <div className={styles.clear_20} />
                <DataTable />
            </div>
        );
    }
}

export default Content;
